module.exports = __webpack_public_path__ + "static/media/customerInactive.ced5f197.png";